/// <amd-module name="Artifacts/PackageRecycleBin/components/NoPackages" />

import * as Res from "Artifacts/PackageRecycleBin/Resources";
import * as React from "react";
import { useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData } from "VSSUI/ZeroData";

const NoPackages: React.FC = () => {
  const { pageContext } = useComponentContext();
  const imagePath = getAssetLocation(
    pageContext,
    "ms.azure-artifacts/package-recycle-bin/img/recyclebin.svg",
  );

  return (
    <div>
      <ZeroData
        primaryText={Res.RecycleBinNoPackages_Primary}
        secondaryText={<span>{Res.RecycleBinNoPackages_Secondary}</span>}
        imageAltText={Res.RecycleBinNoPackages_ImageAltText}
        imagePath={imagePath}
      />
    </div>
  );
};

export { NoPackages };
